qx.Theme.define('sesalab.theme.icons',
  {
    title: 'Tango',
    aliases: {
      icon: 'resource/icons'
    }
  })
